import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { id: "controls" }
const _hoisted_2 = { id: "innerC" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", null, "Bunga-Bunga", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", null, " Earthquake the movie ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h3", null, " Earthquakes in Iceland in 3D animation", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("option", { value: "-1" }, " Now ", -1)
const _hoisted_7 = ["value"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<table><tr><th style=\"background-color:#f00;color:white;width:50px;\">0-4</th><th style=\"background-color:#f60;color:white;width:50px;\">4-12</th><th style=\"background-color:#ff0;color:black;width:50px;\">12-24</th><th style=\"background-color:#36c;color:white;width:50px;\">24-36</th><th style=\"background-color:#006;color:white;width:50px;\">36-48</th><th style=\"background-color:#666;color:white;width:50px;\">48+</th></tr></table>", 1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("a", { href: "https://www.vedur.is/skjalftar-og-eldgos/jardskjalftar/reykjanesskagi/" }, " Reykjanes page", -1)
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<br><div class=\"fb-like\" data-href=\"http://blitzkopf.github.io/\" data-layout=\"button_count\" data-action=\"like\" data-show-faces=\"true\" data-share=\"true\"></div><div id=\"credits\"><p class=\"credit-list\">Created by <a href=\"mailto:blitzkopf@gmail.com\">Yngvi Þór</a> using WebGL, inspired by <a href=\"http://baering.github.io\">3dBulge</a> data provided by <a href=\"http://www.rasmuskr.dk\" target=\"_blank\">RasmusKr</a> and <a href=\"https://www.vedur.is/\"> Veðurstofa Íslands </a></p></div>", 3)

import { defineComponent ,computed, onMounted,ref }  from 'vue';
import { useStore } from '../store';
import { MutationType } from '../store/mutations'
import  apiClient from '../dataloads'
import { loadQuakesSkjalftalisa } from '../utils/quake'
export interface Props {
  open?: boolean,
	overlay: boolean,
	fullheight: boolean,
	fullwidth: boolean,
	right: boolean,
	expandOnHover: boolean,
	reduce: boolean
}



export default /*#__PURE__*/_defineComponent({
  __name: 'BungaControls',
  emits: ['quakesLoaded'],
  setup(__props, { emit }) {



const store = useStore();
const mapdepth = computed({
		get: ()=> store.state.animParams.mapdepth ,
		set: (value:number)=> { 
				store.commit(MutationType.SetMapdepth,value);
		},
},)
const depthMult = computed({
				get: ()=> store.state.animParams.depthMultiplier ,
				set: (value:number)=> { 
						store.commit(MutationType.SetDepthMultiplier,value);
				},
		},)
const minQuakeSize = computed({
				get: ()=> store.state.animParams.minQuakeSize ,
				set: (value:number)=> { 
						store.commit(MutationType.SetMinQuakeSize,value);
				},
		},)
/*var eT = Date.now();
const endTime = computed ({
	get: () =>  { return new Date(eT);},
	set: (value:Date) => {
		eT = value.getDate();
	}
})*/
const presets= [ 
	{
		name: 'Bárðarbunga 2014',
		start_time :"2014-08-13 21:30:00",
		end_time :"2014-08-30 21:30:00",
	},
	{
		name: 'Geldingadalir 2021',
		start_time:"2021-03-05 21:30:00",
		end_time:"2021-03-19 21:30:00",
	},
	{
		name: '5vh 2010',
		start_time:"2010-03-14 21:30:00",
		end_time:"2010-03-20 23:30:00",
	},
	{
		name: 'Eyjafjallajökull 2010',
		start_time:"2010-04-07 21:30:00",
		end_time:"2010-04-14 23:30:00",
	},			{
		name: 'Grímsvötn 2011',
		start_time :"2011-05-19 21:30:00",
		end_time :"2011-05-23 00:00:00",
	},


];
const tTime = new Date() 
const endTime = ref(new Date());
tTime.setTime(tTime.getTime()-7*24*60*60*1000);
const startTime = ref(tTime);
const presetSel = ref(-1);

const fetch= () => {
	//Vue.axios.get('earthquakes/',{params:{date:'72-hoursago'}}).then( result=> {
	//        return loadQuakesRasmus(result.data,this.$store.state.animParams);  

	console.log(this);

	apiClient.post('/array',{
		"start_time":startTime.value.toISOString().substring(0,19).replace('T',' '),
		"end_time":endTime.value.toISOString().substring(0,19).replace('T',' '),
		//"start_time":"2021-03-05 21:30:00",
		//"end_time":"2021-03-19 21:30:00",
		//"start_time":"2014-08-13 21:30:00",
		//"end_time":"2014-08-30 21:30:00",
		//"start_time":"2010-04-07 21:30:00",
		//"end_time":"2010-04-14 23:30:00",

		"depth_min":0,"depth_max":25,"size_min":0,"size_max":18,
		"magnitude_preference":["Mlw","Autmag"],"event_type":["qu"],"originating_system":["SIL picks"],
		"area":[[68,-32],[61,-32],[61,-4],[68,-4]],
		"fields":["event_id","lat","long","depth","time","magnitude","event_type","originating_system"]
	})
	.then( result=> {
		console.log(this);
		return loadQuakesSkjalftalisa(result.data,store.state.animParams);
		})
	.then(qdata => {
			emit('quakesLoaded',qdata);
		})
	/*.catch(error => {
		throw new Error(`API ${error}`);
		})*/;
}
const handlePresets = () => {
	const selection = presets[presetSel.value];
	startTime.value = new Date(selection.start_time);
	endTime.value = new Date(selection.end_time);
	fetch();

}
const mounted = async () => {
	await fetch()
}

onMounted(mounted);


const open=ref(true);

/*const props = withDefaults(defineProps<Props>(), {
	open: true,
			overlay: false,
			fullheight: true,
			fullwidth: false,
			right: false,
			expandOnHover: true,
			reduce: true,
})
*/
			

return (_ctx: any,_cache: any) => {
  const _component_o_switch = _resolveComponent("o-switch")!
  const _component_o_field = _resolveComponent("o-field")!
  const _component_o_select = _resolveComponent("o-select")!
  const _component_o_datetimepicker = _resolveComponent("o-datetimepicker")!
  const _component_o_button = _resolveComponent("o-button")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_o_field, null, {
        default: _withCtx(() => [
          _createVNode(_component_o_switch, {
            value: true,
            modelValue: open.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((open).value = $event))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" hide/show controls ")
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _withDirectives(_createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _hoisted_5,
        _createVNode(_component_o_field, { label: "period" }, {
          default: _withCtx(() => [
            _createVNode(_component_o_select, {
              onChange: _cache[1] || (_cache[1] = ($event: any) => (handlePresets())),
              modelValue: presetSel.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((presetSel).value = $event))
            }, {
              default: _withCtx(() => [
                _hoisted_6,
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(presets, (p, i) => {
                  return _createElementVNode("option", {
                    key: i,
                    value: i
                  }, _toDisplayString(p.name), 9, _hoisted_7)
                }), 64))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_o_field, { label: "start time" }, {
          default: _withCtx(() => [
            _createVNode(_component_o_datetimepicker, {
              rounded: "",
              placeholder: "Click to select...",
              icon: "calendar",
              locale: "en-gb",
              datepicker: { 'show-week-number':false },
              timepicker: { 'enable-seconds':false, 'hour-format':'24' },
              modelValue: startTime.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((startTime).value = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_o_field, { label: "end time" }, {
          default: _withCtx(() => [
            _createVNode(_component_o_datetimepicker, {
              rounded: "",
              placeholder: "Click to select...",
              icon: "calendar",
              locale: "en-gb",
              datepicker: { 'show-week-number':false },
              timepicker: { 'enable-seconds':false, 'hour-format':'24' },
              modelValue: endTime.value,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((endTime).value = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_o_button, { onClick: fetch }, {
          default: _withCtx(() => [
            _createTextVNode("Play")
          ]),
          _: 1
        }),
        _createTextVNode(" Depth of map:(pgUp/pgDown)"),
        _hoisted_8,
        _withDirectives(_createElementVNode("input", {
          id: "mapdepth",
          type: "range",
          min: "-40",
          max: "2",
          step: "1",
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((mapdepth).value = $event))
        }, null, 512), [
          [_vModelText, mapdepth.value]
        ]),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          id: "mapdepthDisp",
          editable: "false",
          class: "disp",
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((mapdepth).value = $event))
        }, null, 512), [
          [_vModelText, mapdepth.value]
        ]),
        _hoisted_9,
        _createTextVNode(" Minimum quake size: "),
        _hoisted_10,
        _withDirectives(_createElementVNode("input", {
          id: "minQuakeSize",
          type: "range",
          min: "0",
          max: "8",
          step: "0.2",
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((minQuakeSize).value = $event))
        }, null, 512), [
          [_vModelText, minQuakeSize.value]
        ]),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          id: "minQuakeSizeDisp",
          editable: "false",
          class: "disp",
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((minQuakeSize).value = $event))
        }, null, 512), [
          [_vModelText, minQuakeSize.value]
        ]),
        _createTextVNode(),
        _hoisted_11,
        _createTextVNode(" Depth multiplier:(pgUp/pgDown)"),
        _hoisted_12,
        _withDirectives(_createElementVNode("input", {
          id: "depthmult",
          type: "range",
          min: "0.5",
          max: "4",
          step: "0.1",
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((depthMult).value = $event))
        }, null, 512), [
          [_vModelText, depthMult.value]
        ]),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          id: "depthmultDisp",
          editable: "false",
          class: "disp",
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((depthMult).value = $event))
        }, null, 512), [
          [_vModelText, depthMult.value]
        ]),
        _hoisted_13,
        _createTextVNode(" Earthquake age in hours: "),
        _hoisted_14,
        _createTextVNode(" The magnitude of each earthquake will detirmine the the size of the bubble."),
        _hoisted_15,
        _createTextVNode(" Also see the Icelandic Meteorological Institute "),
        _hoisted_16,
        _createTextVNode(),
        _hoisted_17
      ], 512), [
        [_vShow, open.value]
      ])
    ])
  ]))
}
}

})